import { Button } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"
import { Paths } from "../../common/commonConstants"
import { useIsLoggedIn } from "../commons/utils"

const pillStyle = {
  bg: "white",
  borderRadius: "full",
  color: "#861F41",
  fontWeight: "600",
  fontSize: "14px",
  height: "32px",
  px: "16px",
  _hover: { bg: "rgba(255,255,255,0.9)" }
}

interface ProductFilterHeaderButtonProps {
  onNavigate?: () => void
}

export const ProductFilterHeaderButton = ({ onNavigate }: ProductFilterHeaderButtonProps): JSX.Element => {
  const navigate = useNavigate()
  const isLoggedIn = useIsLoggedIn()

  const handleClick = (): void => {
    onNavigate?.()
    navigate(isLoggedIn ? Paths.FMP.PRODUCT_FILTER : Paths.PRODUCT_FILTER)
  }

  return (
    <Button {...pillStyle} onClick={handleClick}>
      Product Filter
    </Button>
  )
}
